<script>
import { loadScript, unloadScript } from '@/utils/load-script'
import moment from 'moment'

const googleSurveySrc = 'https://apis.google.com/js/platform.js?onload=renderOptIn'

export default {
	lang: 'shop',
	inject: ['getAppMessageDialog'],
	provide() {
		return {
			refreshOrder: () => this.loadOrder(),
		}
	},
	data() {
		return {
			order: null,
			loading: true,
			firstLoading: true,
			guestHash: false,
		}
	},
	trackPageView() {
		let url = this.$router.resolve({
			name: this.$route.name,
			params: {
				...this.$route.params,
				id: '__ID__',
			},
			query: this.$route.query,
		}).href
		return { location: url }
	},
	methods: {
		async loadOrder() {
			const { hash } = this.$route.query || {}
			await this.$shopApi.get({
				url: (hash ? '/guest-order/' : '/user/order/') + this.$route.params.id,
				query: hash ? { hash } : undefined,
				loading: (v) => (this.loading = v),
				onSuccess: async ({ data }) => {
					this.order = this.$assign({}, data.order)
					await this.updateOrderEvents()
					this.firstLoading = false
				},
				onError: () => {
					let route
					if (this.$store.get('shop/user')) {
						route = { name: 'user.orders' }
					} else {
						route = { name: 'home', query: { redirect: `/user/orders/${this.$route.params.id}` } }
					}
					return this.$router.replace(route).then(() => {
						this.$store.set('shop/loginDrawer', true)
					})
				},
			})
		},
		async callEvent(event) {
			const { hash } = this.$route.query || {}
			const basePath = hash ? `/guest-order` : `/user/order`
			await this.$shopApi.put(`${basePath}/${this.order.id}/${event}`, {
				query: hash ? { hash } : undefined,
			})
		},
		async updateOrderEvents() {
			if (!this.order.confirmedEvt) {
				this.order.confirmedEvt = true
				await this.callEvent('confirmed-evt')
				this.$eventer().trigger('order:confirmed:view', { order: this.order })
			}
			if (this.order.paymentStatus == 'paid' && !this.order.paidEvt) {
				this.order.paidEvt = true
				await this.callEvent('paid-evt')
				this.launchGoogleSurvey()
				this.$eventer().trigger('order:paid:view', { order: this.order })
			}
		},
		async launchGoogleSurvey() {
			const config = this.$srv('GoogleReviewsSurvey')
			if (!config?.merchantId) return
			this.surveyLaunched = true

			const order = this.order
			const [delivery] = order.deliveries || []
			const address = delivery?.toAddress || delivery?.clientAddress
			const delCountry = address?.zipcode?.state?.country.iso || 'AR'
			const delDate =
				delivery?.etaToDate ||
				moment(order.statusesAt?.payment?.paid || undefined)
					.add(config.deliveryDays || 10, 'days')
					.format('YYYY-MM-DD')
			const eans = order.items
				.flatMap((x) => {
					return String(x.ean || '')
						.split(',')
						.map((y) => y.trim())
				})
				.filter(Boolean)
				.filter((x) => /^\d+$/.test(x))

			window.renderOptIn = function () {
				window.gapi.load('surveyoptin', function () {
					window.gapi.surveyoptin.render({
						merchant_id: parseInt(config.merchantId),
						order_id: order.code,
						email: order.buyer.email,
						delivery_country: delCountry,
						estimated_delivery_date: delDate,
						products: [...new Set(eans)].map((x) => ({ gtin: x })),
					})
				})
			}

			loadScript(googleSurveySrc)
		},
	},
	mounted() {
		this.loadOrder().then(() => {
			if (this.order) {
				this.$eventer().trigger('order:view', { order: this.order })
			}
		})
	},
	beforeDestroy() {
		if (this.surveyLaunched) {
			window.renderOptIn = null
			unloadScript(googleSurveySrc)
		}
	},
}
</script>

<template>
	<v-container v-if="$route.query.hash" class="pa-md-6">
		<div class="text-h4 mb-4">{{ 'Detalle de compra' | lang }}</div>
		<v-divider class="mb-4"></v-divider>
		<UserOrderDetail-Complete :order="order" :loading="loading" :first-loading="firstLoading" />
	</v-container>
	<UserpanelLayout v-else :title="$lang('Detalle de compra')">
		<UserOrderDetail-Complete :order="order" :loading="loading" :first-loading="firstLoading" />
	</UserpanelLayout>
</template>

